import { useLanguage } from '../context/LanguageContext';
import { Award, ShieldCheck, Heart, Sparkles, Truck, RotateCcw } from 'lucide-react';

export default function BenefitsSection({ onSubscribeClick }) {
  const { t } = useLanguage();

  const benefits = [
    { icon: Award, title: t('benefit_1'), desc: t('benefit_1_desc') },
    { icon: Sparkles, title: t('benefit_2'), desc: t('benefit_2_desc') },
    { icon: Heart, title: t('benefit_3'), desc: t('benefit_3_desc') },
    { icon: ShieldCheck, title: t('benefit_4'), desc: t('benefit_4_desc') },
    { icon: Truck, title: t('benefit_5'), desc: t('benefit_5_desc') },
    { icon: RotateCcw, title: t('benefit_6'), desc: t('benefit_6_desc') },
  ];

  return (
    <section id="benefits" className="py-10 md:py-14 bg-brand-cream">
      <div className="section-container">
        <div className="text-center mb-8">
          <span className="sticker-badge mb-3">{t('benefits_badge')}</span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-brand-brown mt-3 mb-3">
            {t('benefits_title')}
          </h2>
          <p className="text-brand-muted text-base max-w-2xl mx-auto">
            {t('benefits_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 hover:shadow-lg transition-all hover:-translate-y-1"
              data-testid={`benefit-${index}`}
            >
              <div className="w-12 h-12 bg-brand-orange/10 rounded-xl flex items-center justify-center mb-4">
                <benefit.icon className="w-6 h-6 text-brand-orange" />
              </div>
              <h4 className="font-heading font-semibold text-brand-brown mb-2">
                {benefit.title}
              </h4>
              <p className="text-brand-muted text-sm">{benefit.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={onSubscribeClick}
            className="btn-primary text-base px-6 py-3"
            data-testid="benefits-cta"
          >
            {t('hero_cta')} →
          </button>
        </div>
      </div>
    </section>
  );
}
